import { css } from '@/styled-system/css';

export const cardStyles = css.raw({
  alignItems: 'center',
  border: 'solid',
  borderColor: 'border.muted',
  borderRadius: '300',
  borderWidth: '1px',
  display: 'flex',
  paddingBlock: 'tight',
  paddingInline: 'default',
  minWidth: 0,
});

export const contentStyles = css.raw({
  truncate: true,
  maxWidth: { base: '100px', md: '200px', lg: '260px' },
});
